import React from 'react';
import PropTypes from 'prop-types';
// Styles
import {
  Hero,
  HeroContainer,
  CenteredContent,
  Title,
  Subtitle,
  ContentWrapperNoCard,
} from './styles';
// Utils
import { consistentString } from '../../utils/content-formatting';
import { useLayout } from '../layout/context';

const HeroNoCard = ({ content }) => {
  const {
    image,
    title,
    subtitle,
    blackText,
    alignImage,
    removeMarginBottom = false,
  } = content;

  const { insideContainer } = useLayout();
  if (!image) return null;

  return (
    <HeroContainer $removeMarginBottom={removeMarginBottom || !insideContainer}>
      <Hero
        $image={image}
        $alignImage={(alignImage && consistentString(alignImage)) || 'middle'}
      >
        {(title || subtitle) && (
          <ContentWrapperNoCard $position="center">
            <CenteredContent $black={blackText}>
              {title && <Title>{title}</Title>}
              {subtitle && <Subtitle>{subtitle}</Subtitle>}
            </CenteredContent>
          </ContentWrapperNoCard>
        )}
      </Hero>
    </HeroContainer>
  );
};

HeroNoCard.propTypes = {
  content: PropTypes.shape({
    title: PropTypes.string,
    subtitle: PropTypes.string,
    blackText: PropTypes.bool,
    image: PropTypes.object,
    alignImage: PropTypes.oneOf(['Top', 'Middle', 'Bottom']),
    removeMarginBottom: PropTypes.bool,
  }),
};

export default HeroNoCard;
